import { FeatureDc } from "@evergis/api";
import { useCallback } from "react";
import { addFeature } from "../../resources/addFeature";
import { useSGisLayerRedraw } from "../sgis/useSGisLayerRedraw";
import { useSGisLayer } from "../sgis/useSGisLayers";

export const useCreateFeature = (layerName?: string, tableName?: string) => {
  const [mutation, { error, loading, data }] = addFeature.use();
  const sgisLayer = useSGisLayer(layerName);
  const redrawLayer = useSGisLayerRedraw(sgisLayer);

  const createFeature = useCallback(
    async (feature: FeatureDc) => {
      if (!layerName) return;

      await mutation({
        input: {
          layerName,
          tableName,
          feature,
        },
      });

      redrawLayer();
    },
    [layerName, tableName, mutation, redrawLayer],
  );

  return [createFeature, { error, loading, data }] as const;
};
